import { ReactNode } from 'react'
import styled from 'styled-components'
import logo from '../../assets/esterCareWorkplaceLogo.svg'
import { BodySmall } from '../../components/styles/Typography'
import { theme } from '../../theme/theme'

export const PolicyPageShell = ({ headerRight, children }: { headerRight?: ReactNode; children: ReactNode }) => (
  <Page>
    <Header>
      <Logo src={logo} alt="EsterCare" />
      {headerRight}
    </Header>
    {children}
  </Page>
)

export const PolicyPageMain = ({ children }: { children: ReactNode }) => (
  <Main>
    <Column>{children}</Column>
  </Main>
)

export const PolicyCard = styled.div`
  background: ${theme.color.white};
  border: 1px solid #0000000d;
  border-radius: ${theme.spacing.medium}px;
  overflow: hidden;
`

export const PolicyCardTop = styled(BodySmall)`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: ${theme.spacing.medium}px;
  padding: 14px ${theme.spacing.mediumLarge}px;
  border-bottom: 1px solid ${theme.color.grey2};
  color: ${theme.color.grey5};

  a {
    flex-shrink: 0;
    color: ${theme.color.plumMid};
    text-decoration: underline;
  }
`

export const PolicyCardBody = styled.div`
  padding: ${theme.spacing.xsmall}px ${theme.spacing.mediumLarge}px ${theme.spacing.mediumLarge}px;

  @media screen and (min-width: ${theme.breakpoint.medium}px) {
    padding: ${theme.spacing.xsmall}px 28px 28px;
  }
`

const Page = styled.div`
  flex: 1;
  min-width: 0;
  height: 100%;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  background: ${theme.color.beigeLight};
`

const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${theme.spacing.medium}px;
  padding: 20px ${theme.spacing.large}px;

  @media screen and (max-width: ${theme.breakpoint.medium}px) {
    padding: ${theme.spacing.medium}px;
  }
`

const Logo = styled.img`
  height: 18px;
`

const Main = styled.div`
  flex: 1;
  display: flex;
  justify-content: center;
  padding: ${theme.spacing.xsmall}px ${theme.spacing.mediumLarge}px ${theme.spacing.large}px;

  @media screen and (max-width: ${theme.breakpoint.medium}px) {
    padding: ${theme.spacing.xsmall}px ${theme.spacing.medium}px ${theme.spacing.mediumLarge}px;
  }
`

const Column = styled.div`
  width: 100%;
  max-width: 760px;
`
